<template>
  <v-container>
    <v-card class="card-container">
      <v-tabs v-model="tab" color="deep-purple-accent-4" align-tabs="center">
        <!-- <v-tab value="one">استيراد من لينك</v-tab> -->
        <v-tab value="two">استيراد من اكسل</v-tab>
        <v-tab value="three">حذف مستخدمين</v-tab>
        <v-tab value="four">اضافة مستخدم</v-tab>
      </v-tabs>

      <!-- <v-card-text> -->
      <v-window v-model="tab" class="window-container">
        <!-- <v-window-item value="one">
          <span> استيراد </span>
        </v-window-item> -->

        <v-window-item value="two">
          <v-file-input
            @change="onChange"
            @click:clear="onClear"
            show-size
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            label="إدخال الملف"
          ></v-file-input>

          <v-select update:modelValue="true" clearable chips
        label="المستخدمون المضافون الي" :items="getAddedFromAr('whatsapp')" v-model="added_to"></v-select>
      

          <div>
            عدد المستخدمين: {{ fileInfo.usersNumber }},
            <!-- <template> -->
            <div>
              <span>موجود:</span>
              <v-progress-linear
                v-model="importExcelStatus.existedCount"
                :max="fileInfo.usersNumber"
                color="blue-grey"
                height="25"
              >
                <!-- <template v-slot:default="{ value }"> -->
                <strong>{{
                  importExcelStatus.existedCount ? importExcelStatus.existedCount : 0
                }}</strong>
                <!-- </template> -->
              </v-progress-linear>

              <br />
              <span> تم إنشاؤه:</span>

              <v-progress-linear
                v-model="importExcelStatus.createdCount"
                :max="fileInfo.usersNumber"
                color="blue-grey"
                height="25"
              >
                <!-- <template v-slot:default="{ value }"> -->
                <strong>{{
                  importExcelStatus.createdCount ? importExcelStatus.createdCount : 0
                }}</strong>

                <!-- </template> -->
              </v-progress-linear>
              <br />
            </div>
            <!-- </template> -->
          </div>

          <v-btn @click="importUsersFromExcelHandler" :disabled="excelData.length == 0">
            استيراد
          </v-btn>
        </v-window-item>

        <v-window-item value="three">
          <h2>حذف مستخدمين من [ {{ userFrom }} ]</h2>
          <v-row>
            <v-col cols="8">
              <v-select
                clearable
                chips
                label="المستخدمون المضافون من"
                :items="getAddedFromAr('whatsapp')"
                v-model="userFrom"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-dialog v-model="dialog" persistent width="auto">
                <template v-slot:activator="{ props }">
                  <v-btn
                    color="primary"
                    v-bind="props"
                    style="width: fit-content"
                    :disabled="userFrom == null"
                  >
                    حذف
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    هل أنت متأكد أنك تريد مستخدمين {{ userFrom }} مستخدمين؟ 
                  </v-card-title>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green-darken-1" variant="text" @click="dialog = false">
                      لا
                    </v-btn>
                    <v-btn color="green-darken-1" variant="text" @click="confirmHandler">
                      نعم
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-window-item>


         <v-window-item value="four">
            <!-- User Name -->
            <v-text-field
              ref="user_name"
              v-model="userData.user_name"
              :rules="[() => !!userData.user_name || 'This field is required']"
              :error-messages="errorMessages"
              label="User Name"
              placeholder="User Name"
              required
            ></v-text-field>

            <!-- Phone Number -->
            <v-text-field
              ref="phone_number"
              v-model="userData.phone_number"
              inputmode="numeric"  
              pattern="[0-9]*"      
              :rules="[
                () => !!userData.phone_number || 'This field is required',
                v => /^\d+$/.test(v) || 'Phone number must be numeric'
              ]"
              label="Phone Number"
              placeholder="Phone Number"
              required
            ></v-text-field>

             <v-select update:modelValue="true" clearable chips
        label=" اضافة المستخدم الي" :items="getAddedFromAr('whatsapp')" v-model="user_to"></v-select>

            <!-- Submit Button -->
            <v-btn
              @click="addUserHandler"
              :disabled="!isFormValid"
            >
              اضافة
            </v-btn>
         </v-window-item>

      </v-window>
      <!-- </v-card-text> -->
    </v-card>
  </v-container>
</template>

<style scoped>
.card-container {
  box-shadow: none;
  height: 80vh;
}
.window-container {
  padding: 20px;
}
</style>

<script>
import repository from '../../api/repository'

import * as XLSX from 'xlsx'
import { mapState, mapActions } from 'pinia'
import { useGlobalStore } from '../../stores/global'
import { useUserStore } from '../../stores/user'
import { ADDED_FROM, USERS_FROM, USERS_ADDED_TO } from '@/constants/global'

export default {
  name: 'UsersSettingView',
  components: {},

  data: () => ({
    tab: null,
    dialog: false,
    // usersFrom: ['all', 'excel_sheet', 'url', 'api', 'conversation'],
    userFrom: null,
    userTo: "excel_sheet",
    responseMsgs: [],
    file: null,
    fileInfo: {
      size: 0,
      usersNumber: 0,
    },
    importExcelStatus: {
      existedCount: 0,
      createdCount: 0,
    },
    importUrlStatus: {
      existedCount: 0,
      createdCount: 0,
    },
    excelData: [],
    //  addedFrom: {
    //   instagram: {
    //     all: 'الكل',
    //     api: 'الموقع',
    //     excel_sheet: 'ملف اكسيل',
    //     url: 'لينك',
    //     conversation: 'المحادثات',
    //   },
    //   whatsapp: {
    //     all: 'الكل',
    //     api: 'الموقع',
    //     excel_sheet: 'ملف اكسيل',
    //     url: 'لينك',
    //     conversation: 'المحادثات',
    //   },
    // },
    userData: {
      user_name: null,
      phone_number: null
    },
    added_to: "ملف اكسيل",
    user_to: "الموقع",
    usersAddedTo: USERS_ADDED_TO,
    usersFrom: USERS_FROM,
    addedFrom: ADDED_FROM
  }),
  
  computed: {
    ...mapState(useGlobalStore, ['notifications']),
    isFormValid() {
    return (
      this.userData.user_name &&
      this.userData.phone_number &&
      /^\d+$/.test(this.userData.phone_number)
    );
  }
  },
  methods: {
    ...mapActions(useGlobalStore, ['setNotify', 'setNotifications', 'appendNotifications']),
    ...mapActions(useUserStore, ['setIsUsersUpdated']),

    getAddedFromAr(platform) {
      let retData = [];
      let data = this.usersAddedTo
      console.log({
        data
      })
      data.forEach((status) => {
        retData.push(this.addedFrom[platform][status])
      })

      return retData
    },
    async importUsersFromUrlHandler() {
      const usersUrl = ''; //process.env.VUE_APP_USERS_API;
      const res = await repository.create('users/import-url', {
        url: `${usersUrl}`,
      })
      console.log({
        res
      })
      this.setNotifications(res.data.messages)
      this.importUrlStatus.existedCount += res?.data?.existedCount
      this.importUrlStatus.createdCount += res?.data?.createdCount

      if (this.importUrlStatus.createdCount > 0) {
        this.setIsUsersUpdated()
      }
      this.setNotify()

      console.log({
        res,
      })
    },

    async importUsersFromExcelHandler() {
      const chunkSize = 100
      for (let idx = 0; idx < this.excelData.length; idx += chunkSize) {
        const chunk = this.excelData.slice(idx, idx + chunkSize)
        console.log({
          chunk,
          idx,
          t: idx === 0,
        })


        const key = Object.keys(this.addedFrom.whatsapp).find(
            k => this.addedFrom.whatsapp[k] === this.added_to
        );

        this.userTo = key;
        // chunk['added_to'] = this.userTo

        console.log({
          chunk
        })

        const res = await repository.create('users/import', { data: chunk, added_to:  this.userTo})

        // this.responseMsgs.push(...res.data.data)

        // await this.$store.dispatch('SET_LOGGER', this.responseMsgs)
        if (idx === 0) {
          console.log('setNotifications')
          this.setNotifications(res.data.data.messages)
        } else {
          console.log('appendNotifications')

          this.appendNotifications(res.data.data.messages)
        }
        this.importExcelStatus.existedCount += res.data.data.existedCount
        this.importExcelStatus.createdCount += res.data.data.createdCount

        if (this.importExcelStatus.createdCount > 0) {
          this.setIsUsersUpdated()
        }

        this.setNotify()

        console.log({
          res,
        })
      }
    },
    onClear() {
      console.log('onClear')
      this.fileInfo.usersNumber = 0
      this.excelData = []
    },
    async onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null
      if (this.file) {
        console.log({
          wb: this.file,
        })
        this.fileInfo.size = this.file.size
        const reader = new FileReader()

        reader.onload = async (e) => {
          /* Parse data */
          const bstr = e.target.result
          const wb = XLSX.read(bstr, { type: 'binary' })
          /* Get first worksheet */
          const wsname = wb.SheetNames[0]
          const ws = wb.Sheets[wsname]
          /* Convert array of arrays */
          this.excelData = XLSX.utils.sheet_to_json(ws, { header: 1 })
          this.excelData.shift()
          console.log({
            data: this.excelData,
            wb: this.file,
          })

          this.excelData.forEach((item) => {
            console.log({ is0: item[0] !== undefined, is1: item[1] !== undefined })
          })
          this.excelData = this.excelData.filter((item) => {
            return item[0] !== undefined && item[1] !== undefined
          })
          this.fileInfo.usersNumber = this.excelData.length
        }
        reader.readAsBinaryString(this.file)
        this.file = null
      }
    },
    async confirmHandler() {
      this.dialog = false
      if (this.userFrom) {

        const key = Object.keys(this.addedFrom.whatsapp).find(
            k => this.addedFrom.whatsapp[k] === this.userFrom
        );
        const res = await repository.create('users/reset', { added_from: key })
      
        this.responseMsgs.push(res.data.data)
        // await this.$store.dispatch('SET_LOGGER', this.responseMsgs)
         this.setNotifications([res.data.data])
        this.setIsUsersUpdated()
        console.log({ key })
        this.setNotify()
      }
    },
    async addUserHandler(){
      let data = this.userData;

       const key = Object.keys(this.addedFrom.whatsapp).find(
            k => this.addedFrom.whatsapp[k] === this.user_to
        );

        // this.userTo = key;
      data.added_from = key;
      const res = await repository.create('users', data);
      console.log({ res })
      this.responseMsgs.push(res.data.data)
        // await this.$store.dispatch('SET_LOGGER', this.responseMsgs)
         this.setNotifications([res.data.data])
        this.setIsUsersUpdated()
        this.userData = {
          user_name: null,
          phone_number: null
        }

    }
  },

  async updated() {},
  async created() {
    console.log('users | created')
  },
  async mounted() {
    console.log('users')
  },
}
</script>
